import { render, staticRenderFns } from "./link_selector.vue?vue&type=template&id=a550c8f0&scoped=true"
import script from "./link_selector.vue?vue&type=script&lang=js"
export * from "./link_selector.vue?vue&type=script&lang=js"
import style0 from "./link_selector.vue?vue&type=style&index=0&id=a550c8f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a550c8f0",
  null
  
)

export default component.exports